export default __webpack_public_path__ + "static/media/23.b9dcb5a6.png";